import { render, staticRenderFns } from "./OCambioReservation.vue?vue&type=template&id=160ca62d&"
import script from "./OCambioReservation.vue?vue&type=script&lang=js&"
export * from "./OCambioReservation.vue?vue&type=script&lang=js&"
import style0 from "./OCambioReservation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports